function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import _JSXStyle from "styled-jsx/style";
import { PureComponent } from "react";
import classNames from "classnames";
import SignupFormComponent from "components/core/signups/base-signup-form/signup-form-component";
import PictureComponent from "/components/core/picture/picture-component";
import { componentStyles } from "./header-with-two-columns-and-asset-component.scss";
import colors from "/styles/colors";
import Picture from "/components/core/picture/picture-component";
import VIcon from "/static/svg/competitors-template/v.svg";
import DownArrow from "/static/svg/arrow-down.svg";
const DEFAULT_HOTDOG_COLOR = "brand-purple";
class HeaderWithTwoColumnsAndAssetComponent extends PureComponent {
    render() {
        const { signupForm, hotDog, title, subtitle, asset, textColor, imageWidth, bullets } = this.props;
        let { shadow, image } = asset;
        return /*#__PURE__*/ _jsxs("div", {
            className: `jsx-${componentStyles.__hash}` + " " + `header-with-two-columns-and-asset-component ${[
                "brand-yellow",
                "brand-light-blue"
            ].indexOf(hotDog.color) > -1 ? "" : "white-on-mobile"}`,
            children: [
                hotDog && /*#__PURE__*/ _jsx("div", {
                    style: {
                        backgroundColor: colors[hotDog.color]
                    },
                    className: `jsx-${componentStyles.__hash}` + " " + "hot-dog"
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: `jsx-${componentStyles.__hash}` + " " + "top-line",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: `jsx-${componentStyles.__hash}` + " " + "content-column",
                            children: /*#__PURE__*/ _jsxs("div", {
                                className: `jsx-${componentStyles.__hash}` + " " + "content-inner",
                                children: [
                                    /*#__PURE__*/ _jsx("h1", {
                                        dangerouslySetInnerHTML: {
                                            __html: title
                                        },
                                        className: `jsx-${componentStyles.__hash}` + " " + "content-title"
                                    }),
                                    /*#__PURE__*/ _jsx("h2", {
                                        dangerouslySetInnerHTML: {
                                            __html: subtitle
                                        },
                                        className: `jsx-${componentStyles.__hash}` + " " + "content-subtitle"
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: `jsx-${componentStyles.__hash}` + " " + "content-signup-form",
                                        children: /*#__PURE__*/ _jsx(SignupFormComponent, {
                                            className: "align-left",
                                            focusOnLoad: true
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: `jsx-${componentStyles.__hash}` + " " + "content-bullets",
                                        children: bullets.map((bullet, index)=>/*#__PURE__*/ _jsxs("div", {
                                                className: `jsx-${componentStyles.__hash}` + " " + "bullet",
                                                children: [
                                                    /*#__PURE__*/ _jsx("span", {
                                                        className: `jsx-${componentStyles.__hash}`,
                                                        children: /*#__PURE__*/ _jsx(VIcon, {})
                                                    }),
                                                    /*#__PURE__*/ _jsx("span", {
                                                        className: `jsx-${componentStyles.__hash}`,
                                                        children: bullet
                                                    })
                                                ]
                                            }, index))
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: `jsx-${componentStyles.__hash}` + " " + (classNames("asset-column", {
                                "with-shadow": shadow
                            }) || ""),
                            children: [
                                hotDog && /*#__PURE__*/ _jsx("div", {
                                    style: {
                                        background: colors[hotDog.color] || colors[DEFAULT_HOTDOG_COLOR]
                                    },
                                    className: `jsx-${componentStyles.__hash}` + " " + "hot-dog"
                                }),
                                image && /*#__PURE__*/ _jsx("div", {
                                    style: {
                                        width: `${image.widthPercentage}%`
                                    },
                                    className: `jsx-${componentStyles.__hash}` + " " + "asset-inner",
                                    children: /*#__PURE__*/ _jsx(Picture, _object_spread({
                                        className: "main-image"
                                    }, image))
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: `jsx-${componentStyles.__hash}` + " " + "down-arrow-wrapper",
                            children: /*#__PURE__*/ _jsx(DownArrow, {})
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx(_JSXStyle, {
                    id: componentStyles.__hash,
                    children: componentStyles
                })
            ]
        });
    }
}
export { HeaderWithTwoColumnsAndAssetComponent as default };
HeaderWithTwoColumnsAndAssetComponent.defaultProps = {
    backgroundColor: "brand-purple",
    hotDog: {},
    asset: {},
    title: "",
    subtitle: "",
    signupForm: true,
    textColor: "",
    imageWidth: "50%",
    bullets: []
};
